import { render } from "./ui-table.vue?vue&type=template&id=7c90523e&ts=true"
import script from "./ui-table.vue?vue&type=script&lang=ts"
export * from "./ui-table.vue?vue&type=script&lang=ts"

import "./ui-table.vue?vue&type=style&index=0&id=7c90523e&lang=less"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__